import * as ExcelJS from 'exceljs';

export async function createFileStatisticheAttivita(data: any, filename: string) {
    const templatePath = '/docsTemplate/StatisticheAttivitaTemplate.xlsx';
    
    try {
        const response = await fetch(templatePath);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const arrayBuffer = await response.arrayBuffer();
        
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        
        const worksheet = workbook.getWorksheet(1);
        
        if (!worksheet) {
            throw new Error('Worksheet non trovato nel template');
        }

        insertDataStatisticheAttivita(worksheet, data)
        
        const excelBuffer = await workbook.xlsx.writeBuffer();

        downloadExcelFile(excelBuffer, filename);
    } catch (error) {
        console.error('Errore nel caricamento o elaborazione del template:', error);
        throw error;
    }
}

export async function createFileRendicontoPCTO(data: any, filename: string) {
    const templatePath = '/docsTemplate/RendicontazionePCTOTemplate.xlsx';

    try {
        const response = await fetch(templatePath);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const arrayBuffer = await response.arrayBuffer();
        
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        
        const worksheet = workbook.getWorksheet(1);
        
        if (!worksheet) {
            throw new Error('Worksheet non trovato nel template');
        }

        insertDataRendicontoPCTO(worksheet, data)
        
        const excelBuffer = await workbook.xlsx.writeBuffer();

        downloadExcelFile(excelBuffer, filename);
    } catch (error) {
        console.error('Errore nel caricamento o elaborazione del template:', error);
        throw error;
    }
}

function insertDataRendicontoPCTO(worksheet: ExcelJS.Worksheet, data: any) {
    const setCellValue = (cellAddress: string, value: any) => {
        const cell = worksheet.getCell(cellAddress)
        cell.value = value
    }


}

function insertDataStatisticheAttivita(worksheet: ExcelJS.Worksheet, data: any) {
    const setCellValue = (cellAddress: string, value: any) => {
        const cell = worksheet.getCell(cellAddress)
        cell.value = value
    }

    var numArticolazioni = 0;
    
    if (data.articolazioni && Array.isArray(data.articolazioni) && data.articolazioni.length > 0) {
        numArticolazioni = data.articolazioni.length;
        
        for (let i = 1; i < numArticolazioni; i++) {
            duplicateRow(worksheet, 9 + i - 1);
        }
        
        data.articolazioni.forEach((articolazione: any, index: number) => {
            const rowNumber = 9 + index;

            setCellValue(`C${rowNumber}`, articolazione.Nome || '')
            setCellValue(`F${rowNumber}`, articolazione.Nome || '')
            
            if(data.allievi){
                const allieviArticolazione = data.allievi.find((a: any) => a.IdArticolazione === articolazione.Id)
                if(allieviArticolazione) {
                    setCellValue(`D${rowNumber}`, allieviArticolazione.NumeroAllievi);
                }else{
                    setCellValue(`D${rowNumber}`, 0);
                }
            }else{
                setCellValue(`D${rowNumber}`, 0);
            }

            if(data.workshop){
                const workshop = data.workshop.find((a: any) => a.IdArticolazione === articolazione.Id)
                if(workshop) {
                    setCellValue(`G${rowNumber}`, workshop.NumeroAziendeWorkshop);
                }else{
                    setCellValue(`G${rowNumber}`, 0);
                }
            }else{
                setCellValue(`G${rowNumber}`, 0);
            }
        })
    }
    
    setCellValue('B7', data.annoScolastico || '')
    setCellValue('D7', data.numTotaleAllievi || '')
    setCellValue('E7', data.numCurriculum + ' (' + data.percentualeCurriculum + '%)')
    setCellValue('G7', data.numTotaleAziendeWorkshop || '')
    setCellValue('H7', data.diffAziendeWorkshopAnnoPrecedente || '')

    const diff = numArticolazioni - 1

    setCellValue('C' + (17 + diff), data.numTotaleAziendeColloqui)
    setCellValue('D' + (17 + diff), data.diffAziendeColloquiAnnoPrecedente)
    setCellValue('E' + (17 + diff), data.numTotaleAllieviIscritti)

    setCellValue('G' + (14 + diff), data.diffColloquiSchedulatiAnnoPrecedente)
    setCellValue('F' + (15 + diff), data.numTotaleColloquiSchedulati)
    setCellValue('G' + (16 + diff), data.diffColloquiRegistratiAnnoPrecedente)
    setCellValue('F' + (17 + diff), data.numTotaleColloquiRegistrati)

    setCellValue('H' + (17 + diff), data.numTotaleAbbinamentiFormativi)

    var mergeStartCell = 'B' + (12 + diff);
    var mergeEndCell = 'G' + (12 + diff);
    safeMergeCells(worksheet, mergeStartCell + ':' + mergeEndCell);

    mergeStartCell = 'B' + 7;
    mergeEndCell = 'B' + (10 + diff);
    safeMergeCells(worksheet, mergeStartCell + ':' + mergeEndCell);

    if (data.articolazioni && Array.isArray(data.articolazioni) && data.articolazioni.length > 0) {
        numArticolazioni = data.articolazioni.length
        
        for (let i = 1; i < numArticolazioni; i++) {
            duplicateRow(worksheet, (19 + diff) + i - 1);
        }
        
        data.articolazioni.forEach((articolazione: any, index: number) => {
            const rowNumber = (19 + diff) + index;

            setCellValue(`B${rowNumber}`, articolazione.Nome || '')
            
            if(data.colloqui){
                const colloqui = data.colloqui.find((a: any) => a.IdArticolazione === articolazione.Id)
                if(colloqui) {
                    setCellValue(`C${rowNumber}`, colloqui.NumeroAziendeColloqui);
                }else{
                    setCellValue(`C${rowNumber}`, 0);
                }
            }else{
                setCellValue(`C${rowNumber}`, 0);
            }

            if(data.allieviIscritti){
                const allieviIscritti = data.allieviIscritti.find((a: any) => a.IdArticolazione === articolazione.Id)
                if(allieviIscritti) {
                    setCellValue(`E${rowNumber}`, allieviIscritti.NumeroAllieviIscritti);
                }else{
                    setCellValue(`E${rowNumber}`, 0);
                }
            }

            if(data.abbinamentiFormativi){
                const abbinamentiFormativi = data.abbinamentiFormativi.find((a: any) => a.IdArticolazione === articolazione.Id)
                if(abbinamentiFormativi) {
                    setCellValue(`H${rowNumber}`, abbinamentiFormativi.NumeroAbbinamentiFormativi);
                }else{
                    setCellValue(`H${rowNumber}`, 0);
                }
            }
        })
    }

    const columnLetters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L']
    
    columnLetters.forEach(columnLetter => {
        const column = worksheet.getColumn(columnLetter);
        if (column && column.values && column.values.length > 0) {
            column.width = undefined; 
            column.width = getColumnAutoWidth(worksheet, columnLetter);
        }
    });
}

const safeMergeCells = (worksheet: ExcelJS.Worksheet, range: string) => {
    try {
        try {
            worksheet.unMergeCells(range);
        } catch (e) {
            console.log(e)
        }
        worksheet.mergeCells(range);
    } catch (error) {
        console.warn(`Impossibile mergeare le celle ${range}:`, error);
    }
}

const getColumnAutoWidth = (worksheet: ExcelJS.Worksheet, columnLetter: string): number => {
    const column = worksheet.getColumn(columnLetter);
    let maxWidth = 0;

    column.eachCell({ includeEmpty: false }, (cell) => {
        const cellValue = cell.value ? String(cell.value) : '';
        let cellWidth = cellValue.length;

        if (cell.font && cell.font.bold) {
            cellWidth *= 1.1;
        }
        
        cellWidth = Math.max(cellWidth, 8);
        cellWidth = Math.min(cellWidth, 50); 
        
        maxWidth = Math.max(maxWidth, cellWidth);
    });

    return maxWidth || 10;
}

function duplicateRow(worksheet: ExcelJS.Worksheet, rowNumber: number) {
    const sourceRow = worksheet.getRow(rowNumber);

    const newRow = worksheet.insertRow(rowNumber + 1, []);

    sourceRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        const newCell = newRow.getCell(colNumber);

        newCell.value = cell.value;

        if (cell.style) {
            newCell.style = JSON.parse(JSON.stringify(cell.style));
        }

        if (cell.note) {
            newCell.note = cell.note;
        }
        
        if (cell.dataValidation) {
            newCell.dataValidation = { ...cell.dataValidation };
        }

        if (cell.hyperlink) {
            try {
                const cellText = cell.text || String(cell.value || '');
                newCell.value = {
                    text: cellText,
                    hyperlink: cell.hyperlink
                };
            } catch (e) {
                newCell.value = cell.value;
            }
        }
    })

    if (sourceRow.height) {
        newRow.height = sourceRow.height;
    }
}

function downloadExcelFile(excelBuffer: ArrayBuffer, filename: string) {
    const blob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    window.URL.revokeObjectURL(url);
}